export default __webpack_public_path__ + "static/media/588.98336eca.png";